// removed by extract-text-webpack-plugin
module.exports = {"layout":"_2QJBLPhxnlkZREhhelnWFb","loadingBar":"_1dm0X9_TncUOcQCqEocrK6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Layout.css
// module id = 254
// module chunks = 0